import breadcrumbTemplate from '../common/breadcrumb/breadcrumb.html';
import cmsCategoriesListTemplate from './cms_categories-list.html';
import cmsCategoriesEditTemplate from './cms_categories-edit.html';


angular.module("cmsCategories", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('cms_categories', {
                url: "/cms_categories",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: breadcrumbTemplate,
            })

            .state('cms_categories.list', {
                url: "/list",
                controller: "CmsCategoriesListCtrl",
                template: cmsCategoriesListTemplate,
                requiredPermission: ["CMS_CATEGORIES_READ"]
            })
            .state('cms_categories.edit', {
                url: "/edit/:id",
                controller: "CmsCategoriesEditCtrl",
                template: cmsCategoriesEditTemplate,
                requiredPermission: ["CMS_CATEGORIES_READ"]
            })
    }])
    ;